const ApplicationRuntimeName = 'application';
var UnavailabilityReason;
(function (UnavailabilityReason) {
  UnavailabilityReason["NO_REACH_PROFILE"] = "NO_REACH_PROFILE";
  UnavailabilityReason["NO_CATALOG_ITEMS"] = "NO_CATALOG_ITEMS";
  UnavailabilityReason["NO_REACH_PERMISSION"] = "NO_REACH_PERMISSION";
  UnavailabilityReason["NO_CAPTIONS"] = "NO_CAPTIONS";
  UnavailabilityReason["ENTRY_NOT_READY"] = "ENTRY_NOT_READY";
  UnavailabilityReason["ENTRY_DURATION_LESS_THAN_MIN"] = "ENTRY_DURATION_LESS_THAN_MIN";
  UnavailabilityReason["ENTRY_TYPE_NOT_SUPPORTED"] = "ENTRY_TYPE_NOT_SUPPORTED";
  UnavailabilityReason["NO_RECORDING"] = "NO_RECORDING";
  UnavailabilityReason["GENERAL_ERROR"] = "GENERAL_ERROR";
  UnavailabilityReason["AI_CONSENT"] = "AI_CONSENT";
})(UnavailabilityReason || (UnavailabilityReason = {}));
const ApplicationRuntimeSettingsSchema = {
  type: 'object',
  properties: {
    _schemaVersion: {
      type: 'literal',
      value: '1'
    },
    ks: {
      type: 'primitive',
      value: 'string'
    },
    pid: {
      type: 'primitive',
      value: 'string'
    },
    uiconfId: {
      type: 'primitive',
      value: 'string'
    },
    analyticsServerURI: {
      type: 'primitive',
      value: 'string'
    },
    hostAppName: {
      type: 'primitive',
      value: 'number'
    },
    hostAppVersion: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    reachProfileId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    loadThumbnailWithKS: {
      type: 'primitive',
      value: 'boolean',
      optional: true
    },
    hostedInKalturaProduct: {
      type: 'primitive',
      value: 'boolean',
      optional: true
    },
    kalturaServerURI: {
      type: 'primitive',
      value: 'string'
    },
    clipsOverride: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    postSaveActions: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    widget: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    hidePlaylists: {
      type: 'primitive',
      value: 'boolean',
      optional: true
    },
    hideTags: {
      type: 'primitive',
      value: 'boolean',
      optional: true
    },
    publishCategoryId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    hideAddCaptionsCTA: {
      type: 'primitive',
      value: 'boolean',
      optional: true
    }
  }
};

const AIConsentRuntimeName = 'ai-consent';
const aiConsentRuntimeSettingsSchema = {
  type: 'object',
  properties: {
    _schemaVersion: {
      type: 'literal',
      value: '1'
    },
    ks: {
      type: 'primitive',
      value: 'string'
    },
    pid: {
      type: 'primitive',
      value: 'string'
    },
    hostApp: {
      type: 'primitive',
      value: 'string'
    },
    kaltura: {
      type: 'object',
      properties: {
        analyticsServerURI: {
          type: 'primitive',
          value: 'string'
        },
        hostAppName: {
          type: 'primitive',
          value: 'number'
        },
        hostAppVersion: {
          type: 'primitive',
          value: 'string'
        }
      }
    },
    canSetConsent: {
      type: 'primitive',
      value: 'boolean',
      optional: true
    },
    campaigns: {
      type: 'array',
      optional: true,
      items: {
        type: 'object',
        allowUnknownProperties: true,
        properties: {
          type: {
            type: 'primitive',
            value: 'string'
          },
          campaignId: {
            type: 'primitive',
            value: 'string'
          }
        }
      }
    }
  }
};

const WidgetName = 'unisphere.widget.content-lab';

export { AIConsentRuntimeName, ApplicationRuntimeName, ApplicationRuntimeSettingsSchema, UnavailabilityReason, WidgetName, aiConsentRuntimeSettingsSchema };
